import React from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import { NOTIFICATION_TYPE } from 'enum/messages';
import { chatFontSettings } from 'utils/helpers';

import bellIcon from '../../../images/mobileNotificationsChat/bell-3.png';
import fanClubIcon from '../../../images/fanclub-icon.png';
import goldStarIcon from '../../../images/user/gold-star.png';

import styles from './ChatNotificationsTypes.css';


const images = {
  [NOTIFICATION_TYPE.GOLD_ENTERED_ROOM]: goldStarIcon,
  [NOTIFICATION_TYPE.JOIN_FANCLUB]: fanClubIcon,
  default: bellIcon,
};

function BasicMobileNotification({ message, isBroadcasterChat, isDesktop, chatSettings, type }) {
  const { user: { username } } = UserStore;
  const performerName = ProfileStore.performerDetails.username;

  const image = images[type] || images.default;
  const isAnonymous = message.anonymous === '1';

  const renderText = () => {
    switch (type) {
      case NOTIFICATION_TYPE.ROOM_MODERATOR_PRIVILEGES:
        return message.isRoomModerator ? translate('v2profile.mod.privileges.assigned.short', {
          0: `<span class=${styles.redText}>`,
          1: '</span>',
        }) : translate('v2profile.mod.privileges.removed', {
          0: `<span class=${styles.redText}>`,
          1: '</span>',
        });

      case NOTIFICATION_TYPE.JOIN_FANCLUB:
        return isAnonymous ? translate('strings.Cam4Chat.viewer.joinedFanClub', {
          0: translate('tipping.tipping.anonymous'),
          1: isBroadcasterChat ? username : performerName,
        }) : translate('strings.Cam4Chat.viewer.joinedFanClub', {
          0: message.senderOriginalUsername,
          1: isBroadcasterChat ? username : performerName,
        });

      default:
        return translate('v2profile.entered.room', { 0: message.senderOriginalUsername });
    }
  };

  return (
    <div className={isDesktop ? styles.basicDesktopWrapper : styles.basicWrapper}>
      <img
        alt=""
        className={styles.basicNotifImg}
        src={image}
      />
      <span
        className={styles.basicNotifText}
        style={chatFontSettings(isDesktop, chatSettings)}
      >
        {renderText()}
      </span>
    </div>
  );
}

BasicMobileNotification.defaultProps = {
  chatSettings: {},
  isBroadcasterChat: false,
  isDesktop: true,
  message: {},
  type: '',
};

BasicMobileNotification.propTypes = {
  chatSettings: PropTypes.object,
  isBroadcasterChat: PropTypes.bool,
  isDesktop: PropTypes.bool,
  message: PropTypes.object,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BasicMobileNotification;
